import React, { useState, useEffect } from "react";
import RadioIcon from "../RadioIcon/RadioIcon";

import "../../Styles/globalStyle.css";
import useSize from "../../../Hooks/useSize.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function Attachment(props) {
  
  const buildStyle = useBuildStyle();
  const [checked, setChecked] = useState(false);
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  
  useEffect(() => {
    props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);

  return (
    <div
      draggable={props.draggable}
      onDragStart={(e) => props.onDragStart(e)}
      onClick={props.onClick}
      style={buildStyle(props.style)}
      id={props.data.id}
      
    >
      <div>
        <RadioIcon checked={checked} click={() => {setChecked(!checked); props.onChange(!checked)}} />
      </div>
      <div
        className="label"
        style={{
          userSelect: "none",
          fontSize: props.style.fontSize.value,
        }}
      >
        {props.data.properties.text.value}
      </div>
      
    </div>
  );
}
